import { Link } from 'react-router-dom';

export default function NeutraFooter() {
  return (
    <footer className="w-full" style={{ background: '#111111' }}>
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-12">
          {/* Left: brand + description */}
          <div className="flex flex-col gap-5 max-w-xs">
            <Link
              to="/"
              className="cursor-pointer"
              style={{
                fontFamily: '\'DM Sans\', sans-serif',
                fontWeight: 700,
                fontSize: '1rem',
                color: '#ffffff',
                letterSpacing: '-0.02em',
              }}
            >
              NOVA AI DIGITAL LLC
            </Link>
            <p
              className="text-white/40 text-sm leading-relaxed"
              style={{ fontFamily: '\'DM Sans\', sans-serif' }}
            >
              Get in touch to find out more about digital experiences to effectively reach and engage customers and target audiences.
            </p>
          </div>

          {/* Right: links */}
          <div className="flex gap-16 md:gap-24">
            {/* Company */}
            <div className="flex flex-col gap-4">
              <p
                className="text-white/40 text-xs"
                style={{ fontFamily: '\'DM Sans\', sans-serif', letterSpacing: '0.08em' }}
              >
                Company
              </p>
              <div className="flex flex-col gap-3">
                {[
                  { label: 'Home', path: '/' },
                  { label: 'About', path: '/about' },
                  { label: 'Contact', path: '/contact' },
                  { label: 'Cases', path: '/cases' },
                  { label: 'Services', path: '/services' },
                ].map(({ label, path }) => (
                  <Link
                    key={label}
                    to={path}
                    className="text-white/60 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: '\'DM Sans\', sans-serif' }}
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Legal */}
            <div className="flex flex-col gap-4">
              <p
                className="text-white/40 text-xs"
                style={{ fontFamily: '\'DM Sans\', sans-serif', letterSpacing: '0.08em' }}
              >
                Legal
              </p>
              <div className="flex flex-col gap-3">
                {[
                  { label: 'Privacy Policy', path: '/contact' },
                  { label: 'Licensing', path: '/contact' },
                  { label: 'Terms of Use', path: '/contact' },
                ].map(({ label, path }) => (
                  <Link
                    key={label}
                    to={path}
                    className="text-white/60 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: '\'DM Sans\', sans-serif' }}
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="mt-16 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}
        >
          <p
            className="text-white/30 text-sm"
            style={{ fontFamily: '\'DM Sans\', sans-serif' }}
          >
            &copy; 2025 NOVA AI DIGITAL LLC. Veteran Owned &amp; Operated.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://x.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full border border-white/10 hover:border-white/30 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-twitter-x-line text-white/50 text-sm" />
            </a>
            <a
              href="https://dribbble.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full border border-white/10 hover:border-white/30 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-dribbble-line text-white/50 text-sm" />
            </a>
            <a
              href="https://linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full border border-white/10 hover:border-white/30 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-linkedin-line text-white/50 text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
